import React, { useCallback } from 'react';
import { IFilterSelectButtonProps } from '../../_type';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import './index.scss';

// 组装接口配置和页面配置的相关信息传递给子组件 ，如：nameEn、nameCn、formatter、width、tooltipEn、tooltipCn等
const FilterSelectButton = (props: IFilterSelectButtonProps) => {
  const { selectedRadio, name, value, formatMessage } = props || {};
  const { selectedText, text, formatter = '' } = selectedRadio || {};
  const { radioSelectedValue, inputValue } = value || {};
  const { max, min } = inputValue || {};
  const maxVal = dataFormat({value: max, formatRule: formatter});
  const minVal = dataFormat({value: min, formatRule: formatter});

  // 标题渲染
  const renderTitle = useCallback(() => {
    if(radioSelectedValue === 'all') {
      return selectedText ? selectedText: text;
    }
    if(radioSelectedValue === 'percent') {
      return `${formatMessage({id: 'dbb_input_top'})} ${max}%`;
    } 
    if(radioSelectedValue === 'number'){
      return `${formatMessage({id: 'dbb_input_top'})} ${maxVal}`;
    }
    if(radioSelectedValue === 'custom') {
      return `${min ==='' ? formatMessage({id: 'dbb_input_custom_min'}) : minVal } ~ ${max ==='' ? formatMessage({id: 'dbb_input_custom_max'}) : maxVal }`;
    }
  }, [formatMessage, max, maxVal, min, minVal, radioSelectedValue, selectedText, text]);

  return <div className='dbb-range-selector-title'>
    <span className="db-single-select-button-text">
      {name || ''}
    </span>

    <span className="dbb-range-selector-title-value">
      { renderTitle() }
    </span>
  </div>;
};

export default FilterSelectButton;
